import React from 'react';
import SvgIcon from '../../atoms/svg-icon';
import { BQLink } from '../../atoms/bqlink';
import Lottie from 'lottie-react';
import WhiteArrowIcon from './white-down-arrow.json';
import { isMobileOnly as isMobile } from 'react-device-detect';
import BeepsCardWidget from './index';

import './beeps-card-widget.m.css';

const BeepsCardBanner = () => {
  return (
    <>
      {isMobile ? (
        <BeepsCardWidget />
      ) : (
        <BQLink
          href={`/beeps?src=story`}
          styleName="beeps-banner-container"
          target="_blank"
          className="dekstop-only"
        >
          <div styleName="logo-wrap">
            <SvgIcon type="beeps" width="auto" height="18px" source="image" />
            <div styleName="white-icon">
              <Lottie animationData={WhiteArrowIcon} loop={true} autoplay={true} />
            </div>
          </div>
          <div styleName="sub-text">AI-Powered Short Stories</div>
          <span styleName="border"></span>
        </BQLink>
      )}
    </>
  );
};

export default BeepsCardBanner;
